import React from 'react';

//Hooks
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

//Components
import { CheckCircle, XCircle } from 'react-feather';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ScreenHeader from '../../../../components/ScreenHeader/ScreenHeader';
import ScreenFooter from '../../../../components/ScreenFooter/ScreenFooter';

//Styles
import Styles from './Success.module.scss';
import Loader from 'react-loader-spinner';

//Utils
import classNames from 'class-names';
import { ROUTER_URL } from '../../../../const/ROUTER_URL';
import { PAYMENT_STATUS } from '../../../../const/payment/PAYMENT_STATUS';

const Success = () => {
    const { bookType } = useParams();

    const tintColor = useSelector(state => state.companies.tintColor);
    const status = useSelector(state => bookType === 'payment' ? state.payment.status : state.bundles.status);
    const error = useSelector(state => state.payment.error);

    const { t } = useTranslation('common');

    let icon, title;
    switch (status) {
        case PAYMENT_STATUS.PENDING:
            icon = (
                <Loader
                    type={'TailSpin'}
                    color={'#000'}
                    height={64}
                    width={64}
                />
            );
            title = 'bookingSuccessScreen.paymentPending';
            break;
        case PAYMENT_STATUS.OK:
            icon = <CheckCircle size={64} color={tintColor}/>;
            title = bookType === 'payment' 
                ? 'bookingSuccessScreen.yourReservationIsConfirmed'
                : 'bundleSuccessScreen.bundlePurchasedSuccessfully';
            break;
        case PAYMENT_STATUS.ERROR:
            icon = <XCircle size={64} color={'red'}/>;
            title = error;
            break;
        default:
            icon = <XCircle size={64} color={'red'}/>;
            title = 'bookingSuccessScreen.paymentFailed';
            break;
    }

    return (
        <>
            <ScreenHeader>
                <p className={Styles.title} data-testid='data-test-thankYou-title'>
                    {t('bookingConfirmScreen.thankYou')}
                </p>
            </ScreenHeader>

            <div className={classNames(Styles.container, 'py-5')} data-testid='data-test-thankYou-container'>
                {icon}

                <p className={classNames(Styles.message, 'mb-0')} data-testid={`data-test-thankYou-message-${status}`}>
                    {t(title)}
                </p>
            </div>

            <ScreenFooter visible={true}>
                <Button
                    variant={'tint'}
                    size={'lg'}
                    className={Styles.button}
                    as={Link}
                    to={ROUTER_URL.RESERVATIONS}
                    data-testid='data-test-myBookings-button'
                >
                    {t('bookingSuccessScreen.myBookings')}
                </Button>
            </ScreenFooter>
        </>
    );
};

export default Success
